import { MIN_VIEW_COLUMN_WIDTH } from '@constants'
import { CutRestrictionDTO } from '@types/restriction'

type ColumnWithWidth = {
  width?: CutRestrictionDTO
}

export const getDropDownListColumnWidth = (column: ColumnWithWidth): number => {
  const rawWidth = column.width?.value

  if (rawWidth != null && !Number.isNaN(Number(rawWidth))) {
    return Math.max(MIN_VIEW_COLUMN_WIDTH, Number(rawWidth))
  }

  return MIN_VIEW_COLUMN_WIDTH
}

export const getDropDownListTotalWidth = (columns: ColumnWithWidth[]): number => {
  if (!columns.length) {
    return MIN_VIEW_COLUMN_WIDTH
  }

  return columns.reduce((sum, column) => sum + getDropDownListColumnWidth(column), 0)
}
